import { EndpointPathNames } from "@/shared/config/endpoint-path";
import { BaseRoundButton } from "@/shared/components/button/base-round-button";
import { MailAddressForm } from "@/shared/components/text-box/mail-address-form";
import { SimpleForm } from "@/shared/components/text-box/simple-form";
import React, { useEffect } from "react";
import { useLoginContext } from "@/features/auth/contexts/login-context";
import { useLocation, useNavigate } from "react-router-dom";
import { LoginHeader } from "@/shared/components/header/login-header";
import { Footer } from "@/shared/components/footer/footer";

export const SignUpCompleted = () => {
  type PageState = {
    userName: string;
    email: string;
  }
  
  const {
    setEmail,
  } = useLoginContext();
  const navigate = useNavigate();
  const location = useLocation();
  const state = location.state as PageState | null;
  useEffect(() => {
    if (!state || !state.userName || !state.email) {
      navigate(EndpointPathNames.ERROR, { replace: true });
    }
  }, [state]);

  if (!state || !state.userName || !state.email) {
    return null; // エラー遷移するまで描画しない
  }
//  const snackBarMessage = (location.state as string) ?? "";
//  const { openBaseSnackBar } = useContext(BaseSnackBarContext);
//  useEffect(() => {
//    if (snackBarMessage !== "") {
//      openBaseSnackBar(snackBarMessage);
//    }
//  }, [snackBarMessage, openBaseSnackBar]);

  // メールアドレスフォームに付与するID
  const mailAddressFormId = "signUpPass";
  // ユーザー名フォームに付与するID
  const userNameFormId = "signUpPass";

  return (
    <>
      <LoginHeader content="新しいアカウントを作成" />
      <main>
        <section id="signUp">
          <nav className="step">
            <ol>
              <li className="done">仮登録メールを送信</li>
              <li className="done">パスワードの設定</li>
              <li className="done">ユーザー名の設定</li>
              <li className="active">登録完了</li>
            </ol>
          </nav>
          <p>新しいアカウントが登録されました</p>
          <ul className="form">
            <li>
              <SimpleForm
                id={userNameFormId}
                initialValue={state.userName}
                isReadOnly={true}
                title="ユーザー名"
                onChange={() => {}}
                labelEnable={true}
              />
            </li>
            <li>
              <MailAddressForm
                id={mailAddressFormId}
                initialValue={state.email}
                title="メールアドレス"
                isReadOnly={true}
              />
            </li>
          </ul>
          <div className="notice">
            <p>登録したメールアドレスとパスワードはログイン時に必要となります。大切に保管してください。</p>
            {/* <p>MoneyLinkを使って金融機関の明細を管理するための準備ができました。このまま明細データの管理を開始できます。</p> */}
          </div>
          <nav className="btns">
            <BaseRoundButton
              buttonText="ログインへ"
              onClick={() => {
                setEmail(state.email);
                navigate(EndpointPathNames.LOGIN)
              }}
              isActive={true}
              className="btn-base"
            />
          </nav>
        </section>
      </main>
      <Footer />
    </>
  );
};
